// Imported first by src/index.tsx: Sidebar.tsx and PublicSidebar.tsx read localStorage while they
// are imported, so values must already decrypt by then. See docs/LOCAL-STORAGE-ENCRYPTION.md.
import { installStorageEncryption, LEGACY_PREFIX } from './common-misc/cryptoStorage'
import { clearSession, getSessionKey, PORTAL_CREDENTIAL_STORAGE, VSPACE_CREDENTIAL_STORAGE } from './common-rest/cryptoKeys'

const enabled = process.env.REACT_APP_ENCRYPT_STORAGE !== 'false'

// Read natively, before the install below removes them: did an older build seal values with the master key?
function hasLegacyValues(): boolean {
    try {
        for (let i = 0; i < localStorage.length; i++) {
            const name = localStorage.key(i)
            const raw = name === null ? null : localStorage.getItem(name)
            if (raw !== null && raw.indexOf(LEGACY_PREFIX) === 0) return true
        }
    } catch (e) {
        // No localStorage (blocked site data): nothing to clean up.
    }
    return false
}

const hadLegacyValues = hasLegacyValues()

installStorageEncryption(window, {
    getKey: getSessionKey,
    enabled: enabled,
    // Opaque server-issued credentials: a new tab needs them to get its session key back.
    exclude: [VSPACE_CREDENTIAL_STORAGE, PORTAL_CREDENTIAL_STORAGE],
})

// The install removed the enc1: values (roles, user name...) but kept the credential: sign out, so the
// user gets a clean login page instead of being half signed in.
// Debugging switch REACT_APP_ENCRYPT_STORAGE=false: plaintext storage, signed out on every load.
if (!enabled || hadLegacyValues) clearSession()
